const videos = document.querySelectorAll(".js-autoplay");

if (videos.length) {
    const observer = new IntersectionObserver(items => {
        items.forEach(item => {
            if (item.isIntersecting && item.target.paused) {
                item.target.play();
            } else {
                item.target.pause();
            }
        });
    });

    videos.forEach(video => {
        observer.observe(video);
    });
}